import { useTranslation } from "react-i18next";
import { LoadingSpinner } from "ui/shared/LoadingSpinner";

require('./ProgressBar.css');

export type Props = {
    id?: string;
    labelKey: string;
    progress: number; // Progress from 0 to 1
};

export const ProgressBar = ({ id, labelKey, progress }: Props) => {
    const { t } = useTranslation();
    return (
        <div
            id={ id }
            className="progress-bar"
        >
            <LoadingSpinner
                size="tiny"
                textKey={ labelKey }
            />
            <label>
                { t(labelKey) }
            </label>
            <span className="_bar">
                <span
                    className="_progress"
                    style={ {
                        width: `${Math.max(0, Math.min(progress, 1)) * 100}%`,
                    } }
                />
            </span>
        </div>
    );
};
